import { render, staticRenderFns } from "./AddDialect.vue?vue&type=template&id=25f8630d&scoped=true"
import script from "./AddDialect.vue?vue&type=script&lang=js"
export * from "./AddDialect.vue?vue&type=script&lang=js"
import style0 from "./AddDialect.vue?vue&type=style&index=0&id=25f8630d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8630d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f8630d')) {
      api.createRecord('25f8630d', component.options)
    } else {
      api.reload('25f8630d', component.options)
    }
    module.hot.accept("./AddDialect.vue?vue&type=template&id=25f8630d&scoped=true", function () {
      api.rerender('25f8630d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/DemandForm/AddDialect.vue"
export default component.exports